import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=fc7b87b8&scoped=true&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=fc7b87b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7b87b8",
  null
  
)

export default component.exports